module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-02.e9e1d500d0a9f15c695c359545be8d7a.png";